import React from "react";
import { NavLink } from "react-router-dom";
import { Role as RoleType } from "/app/src/models";
/**
 * Renders a role as a list item with a navigation link.
 *
 * @param {Object} props - The component props.
 * @param {RoleType} props.role - The role object containing the id and name.
 * @returns {JSX.Element} The rendered list item with a navigation link.
 */
export default function Role({ role }: { role: RoleType }) {
  return (
    <li className="role">
      <NavLink to={`/users/roles/${role.id}`}>{role.name}</NavLink>
    </li>
  );
}
